<template>
  <div id="ads-page-container" class="section mini is-centered">
    <!-- <div class="columns"> -->
    <!-- <div class="column is-narrow"> -->
    <div v-for="ad of leftAds" :key="ad._id">
      <Ad :type="'MR'" :ad="ad"></Ad>
    </div>
    <!-- </div> -->
    <!-- </div> -->
    <!-- <div class="column is-two-thirds"> -->
    <div v-for="ad of topAds" :key="ad._id">
      <Ad :type="'FB'" :ad="ad"></Ad>
    </div>
    <slot></slot>
    <div v-for="ad of bottomAds" :key="ad._id">
      <Ad :type="'FB'" :ad="ad"></Ad>
    </div>
    <!-- </div> -->
    <div v-for="ad of rightAds" :key="ad._id">
      <Ad :type="'MR'" :ad="ad"></Ad>
    </div>
  </div>
</template>

<script>
import Ad from "@/components/Ad.vue";
import {
  CATEGORY,
  GETTER_NAMES,
  ADS_POSITION_ENUM,
} from "@/store/getters/ads.js";

export default {
  name: "AdsTemplate",
  components: { Ad },
  computed: {
    state() {
      return this.$store.state[CATEGORY];
    },
    getters() {
      return this.$store.getters[CATEGORY];
    },
    adsMap() {
      return this.getters(GETTER_NAMES.GET_ADS_MAP_BY_POSITION);
    },
    ads() {
      return this.state.list;
    },
    topAds() {
      return this.adsMap[ADS_POSITION_ENUM.TOP];
    },
    leftAds() {
      return this.adsMap[ADS_POSITION_ENUM.LEFT];
    },
    rightAds() {
      return this.adsMap[ADS_POSITION_ENUM.RIGHT];
    },
    middleAds() {
      return this.adsMap[ADS_POSITION_ENUM.MIDDLE];
    },
    bottomAds() {
      return this.adsMap[ADS_POSITION_ENUM.BOTTOM];
    },
  },
  // mounted() {
  //   if (this.ads.length === 0 && !this.$store.getters.isUserSubscribed) {
  //     this.$store
  //       .dispatch("fetchAds")
  //       .then(() => {
  //         console.log("Ads ready");
  //       })
  //       .catch(console.error);
  //   }
  // }
};
</script>

<style lang="scss" scoped>
#ads-page-container {
  & > .column:first-child {
    .columns {
      justify-content: flex-end;
    }
  }
}
</style>
